import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const NoticeIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--notice')}
    viewBox="0 0 18 19"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g fill="none" fillRule="evenodd">
      <ellipse cx="8.994" cy="9.698" fill="#3F3F3F" rx="8.994" ry="8.979" />
      <path
        fill="#FFF"
        d="M7.682 3.98h2.466v3.446l-.743 4.238H8.44l-.758-4.238V3.98zM7.84 15v-2.12h2.15V15H7.84z"
      />
    </g>
  </svg>
);

export default NoticeIcon;
